import {loadPnP as getPnP} from '../../services/api/pnp';
import {getCurrentLocale} from '../../utils/i18n';

export const PNP_LOAD_START = 'PNP_LOAD_START';
export const PNP_LOAD_ERROR = 'PNP_LOAD_ERROR';
export const PNP_LOAD_COMPLETE = 'PNP_LOAD_COMPLETE';

export const loadPnP = () => async (dispatch, getState) => {
    const lang = getCurrentLocale();

    const {user} = getState();

    let catalog = user.jwtToken ? user.catalogTenant : null;

    if (!catalog) {
        catalog =
            getCurrentLocale() === 'por'
                ? 'CNPLUS_LATAM_BR'
                : 'CNPLUS_LATAM_LATAM';
    }

    dispatch({type: PNP_LOAD_START});

    try {
        let pnp = await getPnP(lang, catalog);
        dispatch({type: PNP_LOAD_COMPLETE, pnp});
    } catch (error) {
        console.log(error);
        dispatch({type: PNP_LOAD_ERROR, error});
    }
};
